import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "reactstrap";
import uuidv4 from "uuid/v4";

const TooltipImage = ({ iconClassName, tooltipText, tooltipPosition }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const uuid = useMemo(() => `t${uuidv4().replace(/-/g, "")}`, []);
  return (
    <i key={uuid} id={uuid} className={iconClassName}>
      <Tooltip placement={tooltipPosition} isOpen={isOpen} target={uuid} toggle={toggle}>
        {tooltipText}
      </Tooltip>
    </i>
  );
};

TooltipImage.propTypes = {
  iconClassName: PropTypes.string,
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltipPosition: PropTypes.string
};

TooltipImage.defaultProps = {
  iconClassName: "",
  tooltipText: "",
  tooltipPosition: "top"
};

export default TooltipImage;
